import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star } from 'lucide-react';
const GOOGLE_REVIEW_URL = 'https://g.page/r/Cat9FuHdU1RAEAE/review';
interface GoogleReviewPromptProps {
  isVisible: boolean;
  onDismiss?: () => void;
}
export function GoogleReviewPrompt({
  isVisible,
  onDismiss
}: GoogleReviewPromptProps) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (isVisible) {
      const isDismissed = sessionStorage.getItem('rewrite_review_dismissed');
      if (!isDismissed) {
        setShow(true);
      }
    } else {
      setShow(false);
    }
  }, [isVisible]);
  const handleDismiss = () => {
    setShow(false);
    sessionStorage.setItem('rewrite_review_dismissed', 'true');
    if (onDismiss) onDismiss();
  };
  const handleLeaveReview = () => {
    window.open(GOOGLE_REVIEW_URL, '_blank', 'noopener,noreferrer');
    handleDismiss();
  };
  return <AnimatePresence data-id="element-2097">
      {show && <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: -10
    }} transition={{
      duration: 0.3
    }} className="mt-6 bg-[#0a0a0a] border border-gray-800 rounded-xl p-5 relative overflow-hidden group" data-id="element-2098">
          {/* Subtle gradient background */}
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/5 via-transparent to-transparent opacity-50" data-id="element-2099" />

          <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center gap-4" data-id="element-2100">
            {/* Google Stars Icon */}
            <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-[#4285F4] via-[#34A853] to-[#FBBC05] flex items-center justify-center shadow-lg" data-id="element-2101">
              <Star className="w-6 h-6 text-white fill-white" data-id="element-2102" />
            </div>

            <div className="flex-1" data-id="element-2103">
              <h4 className="text-white font-bold text-sm mb-1 uppercase tracking-wide" data-id="element-2104">
                Enjoying the Message Rewriter?
              </h4>
              <p className="text-gray-400 text-xs font-mono leading-relaxed" data-id="element-2105">
                Your feedback helps others discover healthier communication
                tools.
              </p>
            </div>

            <div className="flex flex-row sm:flex-col gap-2 w-full sm:w-auto mt-2 sm:mt-0" data-id="element-2106">
              <button onClick={handleLeaveReview} className="flex-1 sm:flex-none bg-[#4285F4] hover:bg-[#3367d6] text-white px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors text-center whitespace-nowrap" data-id="element-2107">
                Leave Review
              </button>
              <button onClick={handleDismiss} className="flex-1 sm:flex-none bg-transparent hover:bg-white/5 text-gray-500 hover:text-gray-300 border border-gray-800 hover:border-gray-600 px-4 py-2 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors text-center whitespace-nowrap" data-id="element-2108">
                Not Now
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}